

export enum Page {
    Home = "/",
    Saved = "/saved",
    Manage = "/manage",
    Login = "/login",
};
